import { useContext, useState, useEffect, useRef } from "react";
import { AuthContext } from "../../context/AuthContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./AuthModal.css";
import { BACKEND_URL } from "../../config";

// ⚠️ YAHAN APNI GOOGLE reCAPTCHA SITE KEY DAALO (Secret Key kabhi frontend me nahi aati, wo backend me jayegi)
const RECAPTCHA_SITE_KEY = "6LduGDwtAAAAABUAXPJfuWMUZjSAxrFzzYIRjtnM";

function AuthModal() {
  const { setUser, setShowAuth, authMode } = useContext(AuthContext);

  const [isSignIn, setIsSignIn] = useState(true);
  const [isForgot, setIsForgot] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    newPassword: ""
  });

  // captcha verify hone ke baad jo token milta hai, usse store karte hain
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const widgetIdRef = useRef(null);

  // FIX: captchaKey ko isSignIn se directly derive karte hain ("signin" / "signup"),
  // is se yeh kabhi random-loop nahi karega - sirf form switch hone par hi badlega
  const captchaKey = isSignIn ? "signin" : "signup";

  useEffect(() => {

    if (authMode === "forgot") {
      setIsForgot(true);
      setIsSignIn(true);
    } else {
      setIsSignIn(authMode === "signin");
      setIsForgot(false);
    }

    setForm({
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      newPassword: ""
    });

    setCaptchaToken(null); // mode badalne par purana captcha state clear

  }, [authMode]);

  useEffect(() => {
  if (isForgot) {
    handleForgotClick();
  }
}, [isForgot]);

 
  useEffect(() => {
    if (isForgot) return;

    widgetIdRef.current = null;
    setCaptchaToken(null);

    let cancelled = false;

    const render = () => {
      if (cancelled) return;
      if (
        !window.grecaptcha ||
        !window.grecaptcha.render ||
        !captchaRef.current ||
        widgetIdRef.current !== null
      ) {
        return;
      }

      try {
        widgetIdRef.current = window.grecaptcha.render(captchaRef.current, {
          sitekey: RECAPTCHA_SITE_KEY,
          callback: (token) => setCaptchaToken(token),
          "expired-callback": () => setCaptchaToken(null)
        });
      } catch (err) {
        
        
        console.log("reCAPTCHA render error:", err);
      }
    };

    if (window.grecaptcha?.render) {
      render(); // FIX: turant render, koi 100ms delay nahi
    } else {
      const timer = setInterval(() => {
        if (window.grecaptcha?.render) {
          clearInterval(timer);
          render();
        }
      }, 200);
      return () => {
        cancelled = true;
        clearInterval(timer);
      };
    }

    return () => {
      cancelled = true;
    };
  }, [captchaKey, isForgot]);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ Forgot click — session se email fetch karo
  const handleForgotClick = async () => {
    try {
      const res = await fetch(
        `${BACKEND_URL}/api.php?module=auth&action=verify_email`,
        {
          method: "POST",
          credentials: "include"    // ✅ session cookie bhejo
        }
      );
      const data = await res.json();
      if (data.success) {
        setForm(prev => ({ ...prev, email: data.email }));  // ✅ DB se email auto-fill
        setIsForgot(true);
      } else {
        alert(data.message);
      }
    } catch {
      alert("Server error ");
    }
  };

  const handleSubmit = async () => {

    // ================= FORGOT PASSWORD ================= (captcha yahan nahi lagta)
    if (isForgot) {
      if (!form.newPassword || !form.confirmPassword) {
        alert("Please fill all fields "); return;
      }
      if (form.newPassword !== form.confirmPassword) {
        alert("Passwords do not match "); return;
      }
      try {
        const res = await fetch(
          `${BACKEND_URL}/api.php?module=auth&action=reset_password`,
          {
            method: "POST",
            credentials: "include",   // ✅ session cookie bhejo
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ new_password: form.newPassword })  // ✅ sirf new_password
          }
        );
        const data = await res.json();
        alert(data.message);
        if (data.success) {
          setIsForgot(false);
          setIsSignIn(true);
          setForm({ name: "", email: "", password: "", confirmPassword: "", newPassword: "" });
        }
      } catch {
        alert("Server error ");
      }
      return;
    }

    // agar checkbox tick nahi hai to aage hi mat badho
    if (!captchaToken) {
      alert("Please verify the captcha");
      return;
    }

    // ================= SIGNUP VALIDATION =================
    if (!isSignIn) {
      if (form.password !== form.confirmPassword) {
        alert("Passwords do not match ");
        return;
      }
    }

    const url = isSignIn
      ? `${BACKEND_URL}/api.php?module=auth&action=login`
      : `${BACKEND_URL}/api.php?module=auth&action=signup`;

    const payload = isSignIn
      ? { email: form.email, password: form.password, captchaToken }
      : { name: form.name, email: form.email, password: form.password, captchaToken };

    try {
      const res = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (data.success) {
        if (isSignIn) {
          setUser(data.user);
          localStorage.setItem("user", JSON.stringify(data.user));
          alert("Login Success ");
        } else {
          alert("Account created! Please sign in ");
          setIsSignIn(true);
        }
        setShowAuth(false);
        setForm({ name: "", email: "", password: "", confirmPassword: "", newPassword: "" });
      } else {
        alert(data.message);
        // fail hone par captcha reset karo, dobara verify karna padega (security ke liye)
        if (window.grecaptcha && widgetIdRef.current !== null) {
          window.grecaptcha.reset(widgetIdRef.current);
        }
        setCaptchaToken(null);
      }

    } catch {
      alert("Server error ");
    }
  };

  return (
    <div className="auth-overlay" onClick={() => setShowAuth(false)}>
      <div className="auth-box" onClick={(e) => e.stopPropagation()}>

        <input type="text" style={{ display: "none" }} />
        <input type="password" style={{ display: "none" }} />

        <button className="close-btn" onClick={() => setShowAuth(false)}>✖</button>

        <h2>
          {isForgot ? "Reset Password" : isSignIn ? "Sign In" : "Sign Up"}
        </h2>

        {/* ================= FORGOT PASSWORD UI ================= */}
        {isForgot && (
          <>
            {/* ✅ DB se aya email — readonly, change nahi ho sakta */}
            <input
              name="email"
              value={form.email}
              readOnly
              style={{ opacity: 0.6, cursor: "not-allowed" }}
            />

            <div className="password-box">
              <input
                name="newPassword"
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                onChange={handleChange}
              />
              <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="password-box">
              <input
                name="confirmPassword"
                type="password"
                placeholder="Confirm New Password"
                onChange={handleChange}
              />
            </div>

            <button onClick={handleSubmit} className="auth-btn">
              Update Password
            </button>

            <p className="switch" onClick={() => { setIsForgot(false); setForm(prev => ({ ...prev, email: "" })); }}>
              Back to Login
            </p>
          </>
        )}

        {/* ================= SIGN IN / SIGN UP UI ================= */}
        {!isForgot && (
          <>
            {!isSignIn && (
              <input
                name="name"
                placeholder="Full Name"
                onChange={handleChange}
              />
            )}

            <input
              name="email"
              placeholder="Email"
              onChange={handleChange}
            />

            <div className="password-box">
              <input
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                onChange={handleChange}
              />
              <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {!isSignIn && (
              <div className="password-box">
                <input
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  onChange={handleChange}
                />
              </div>
            )}

            {/* Google reCAPTCHA "I'm not a robot" checkbox yahan render hoga */}
            {/* FIX: key sirf "signin"/"signup" string hai, isliye yeh bina wajah re-mount nahi hoga */}
            <div
                key={captchaKey}
                ref={captchaRef}
                className="captcha-box"
                style={{ margin: "12px 0", minHeight: "78px" }}
              ></div>

            <button onClick={handleSubmit} className="auth-btn">
              {isSignIn ? "Sign In" : "Sign Up"}
            </button>

            {/* ✅ handleForgotClick — session se email fetch karega */}
            {isSignIn && (
              <p className="switch" onClick={handleForgotClick}>
                Forgot Password?
              </p>
            )}

            <p className="switch" onClick={() => setIsSignIn(!isSignIn)}>
              {isSignIn ? "Create new account" : "Already have account? Sign In"}
            </p>
          </>
        )}

      </div>
    </div>
  );
}

export default AuthModal;
